import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { KeyboardArrowRight } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import styled from "styled-components";
import { useApp } from "../contexts/AppContext";
import { isRtlLanguage } from "../utils";

const StyledLink = styled(Link)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.grey[600],
  "&:hover": {
    color: theme.palette.grey[800],
  },
}));

export interface BreadcrumbsItem {
  label: string;
  onClick?: () => void;
}

interface BreadcrumbsProps {
  items: readonly BreadcrumbsItem[];
}

const BreadcrumbsComponent: React.FC<BreadcrumbsProps> = ({ items }) => {
  const {currentLanguage} = useApp();
  return (
    <Breadcrumbs
      separator={<KeyboardArrowRight fontSize="small" sx={{"transform": isRtlLanguage(currentLanguage) ? "scaleX(-1)" : ""}} />}
      aria-label="breadcrumb"
    >
      {items.map((item, index) => (
        <Box key={index}>
          {index === items.length - 1 ? (
            <Typography color="black" fontWeight={"500"}>
              {item.label}
            </Typography>
          ) : (
            <Link
              sx={{ textDecoration: "none", cursor: "pointer", fontWeight: 500 }}
              color="grey"
              onClick={item.onClick}
            >
              {item.label}
            </Link>
          )}
        </Box>
      ))}
    </Breadcrumbs>
  );
};

export default BreadcrumbsComponent;
